import React from "react"
import { Flex, Rte, Text } from "@capioweb/ui-components/src"
import { LocalesContext } from "../../context"
import { createMarkup } from "../../utils"

interface CapioInformationProps {
	informationText: string
}

const CapioInformation: React.FC<CapioInformationProps> = (props) => {
	const [showMore, setShowMore] = React.useState(false)
	const [showLink, setShowLink] = React.useState(false)
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const contentRef = React.createRef<HTMLDivElement>()
	React.useLayoutEffect(() => {
		if (contentRef?.current) {
			if (contentRef.current.clientHeight < contentRef.current.scrollHeight) {
				setShowLink(true)
			}
		}
	}, [contentRef])
	return (
		<>
			<Rte>
				<Flex
					ref={contentRef}
					flexDirection="column"
					w={1}
					maxh={showMore ? "auto" : { _: 45 }}
					overflow="hidden"
					dangerouslySetInnerHTML={createMarkup(props.informationText)}
				/>
			</Rte>
			{showLink && (
				<Text.Button
					variant="paragraph-16"
					mb={4}
					onClick={() => setShowMore(!showMore)}
					style={{ textDecoration: "underline" }}
				>
					{showMore
						? translate(translationKeys.showLess)
						: translate(translationKeys.showMore)}
				</Text.Button>
			)}
		</>
	)
}

export { CapioInformation }
